/**
 * Bridge Strategy — 站点配置 + 产品路由表
 *
 * 复用 utils/routeConstants.ts 已有常量，
 * 映射为 section JS 友好的短 key。
 */
import {
  aiRemovalURL,
  aiTiktokVideoURL,
  aiUgcVideoURL,
  aiVideoEditURL,
  avatarVideoProURL,
  faceSwapperURL,
  imageEnhanceURL,
  imageGenerateURL,
  imageTranslationURL,
  pricingURL,
  productAvatarURL,
  videoGenerateURL,
  videoTranslateURL,
  voiceCloneURL,
} from '@/utils/routeConstants';

import type { BridgeSiteConfig, LandingBridgeMediator } from '../types';

/** 产品路由表（section JS 通过 bridge.getConfig().routes['key'] 获取） */
const PRODUCT_ROUTES: Record<string, string> = {
  'video-generator': videoGenerateURL,
  'image-generator': imageGenerateURL,
  'video-translator': videoTranslateURL,
  'avatar-generator': avatarVideoProURL,
  'product-avatar': productAvatarURL,
  'face-swap': faceSwapperURL,
  'voice-clone': voiceCloneURL,
  'image-enhancer': imageEnhanceURL,
  'image-translator': imageTranslationURL,
  'ai-removal': aiRemovalURL,
  'video-editor': aiVideoEditURL,
  'tiktok-video': aiTiktokVideoURL,
  'ugc-video': aiUgcVideoURL,
  pricing: pricingURL,
};

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://falcocut.ai';

const siteConfig: BridgeSiteConfig = {
  siteUrl: SITE_URL,
  routes: PRODUCT_ROUTES,
};

export function registerConfigStrategy(bridge: LandingBridgeMediator): void {
  bridge.register('getConfig', () => siteConfig);
}
